import { render, staticRenderFns } from "./RenameModal.vue?vue&type=template&id=dbf11926&scoped=true&"
import script from "./RenameModal.vue?vue&type=script&lang=js&"
export * from "./RenameModal.vue?vue&type=script&lang=js&"
import style0 from "./RenameModal.vue?vue&type=style&index=0&id=dbf11926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf11926",
  null
  
)

export default component.exports